export class AlertsCount {
    currentSeverity: string;
    count: number;

    constructor(json: any) {
        this.currentSeverity = json.current_severity;
        this.count = json.count;
    }
}
